module.exports = __webpack_public_path__ + "img/skills-active.e797b5c6.svg";